/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import moment from "moment";

interface ContasPagas {
  emissao: string;
  numero: string;
  datalan: string;
  parceiro: string;
  historico: string;
  banco: string;
  valor: number;
}

async function RelatorioPagas(dados: ContasPagas[], periodo: string) {

  const linhas: any[] = [];

  const totalGeral = dados.reduce(
    (acc, item) => acc + (item?.valor ?? 0),
    0
  );

  dados.forEach((r) => {

    linhas.push([
      {
        text: moment(r.emissao).format("DD/MM/YYYY"),
        fontSize: 8
      },
      {
        text: moment(r.datalan).format("DD/MM/YYYY"),
        fontSize: 8
      },
      {
        text: r.numero ?? "",
        fontSize: 8
      },
      {
        text: r.parceiro ?? "",
        fontSize: 8
      },
      {
        text: r.historico ?? "",
        fontSize: 8
      },
      {
        text: r.banco ?? "",
        fontSize: 8
      },
      {
        text: formatMoney(r.valor),
        alignment: "right",
        bold: true,
        fontSize: 8
      }
    ]);

  });

  const documentDefinition: any = {

    pageSize: "A4",
    pageOrientation: "landscape",

    pageMargins: [25, 25, 25, 25],

    content: [

      {
        text: process.env.REACT_APP_URL_EMPRESA,
        fontSize: 14,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 4]
      },

      {
        text: "RELATÓRIO DE CONTAS PAGAS",
        fontSize: 12,
        bold: true,
        alignment: "center"
      },

      {
        text: periodo,
        alignment: "center",
        fontSize: 9,
        margin: [0, 0, 0, 10]
      },

      {
        table: {

          headerRows: 1,

          widths: [
            60,  // emissão
            60,  // lançamento
            50,  // número
            200, // parceiro
            "*", // histórico
            60, // banco
            50   // valor
          ],

          body: [

            [
              { text: "Emissão", bold: true, fillColor: "#e5e7eb", fontSize: 9 },
              { text: "Pagamento", bold: true, fillColor: "#e5e7eb", fontSize: 9 },
              { text: "Número", bold: true, fillColor: "#e5e7eb", fontSize: 9 },
              { text: "Parceiro", bold: true, fillColor: "#e5e7eb", fontSize: 9 },
              { text: "Histórico", bold: true, fillColor: "#e5e7eb", fontSize: 9 },
              { text: "Banco", bold: true, fillColor: "#e5e7eb", fontSize: 9 },
              { text: "Valor", bold: true, alignment: "right", fillColor: "#e5e7eb", fontSize: 9 }
            ],

            ...linhas

          ]

        },

        layout: {

          fillColor: (rowIndex: number) => {

            if (rowIndex === 0) return null;

            return rowIndex % 2 === 0 ? "#f9fafb" : null;

          },

          hLineColor: () => "#d1d5db",
          vLineWidth: () => 0

        }

      },

      {
        text: "TOTAL PAGO: " + formatMoney(totalGeral),
        alignment: "right",
        bold: true,
        fontSize: 11,
        margin: [0, 15, 0, 0]
      }

    ]

  };

  pdfMake.createPdf(documentDefinition).open();

}

function formatMoney(value: number) {

  const v = Number(value ?? 0);

  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(v.toFixed(2)));

}

export default RelatorioPagas;